import React, { useEffect, useState } from 'react';
import { Row, Col } from 'react-bootstrap';
import { Doughnut } from "react-chartjs-2";
import UserService from '../../../../controllers/UserService';
import $ from 'jquery';
import AuthService from '../../../../controllers/AuthService';

const TopStrengthSummary = props => {
    const filterYear = props.filterYear ?? null
    const filterTerm = props.filterTerm ?? null
    const [hGraphData1, setHGraphData1] = useState(null);
    const [hGraphData2, setHGraphData2] = useState(null);
    const [keyH1, setSetKeyH1] = useState([]);
    const [keyH2, setSetKeyH2] = useState([]);
    const [strengths, setStrengths] = useState([]);
    const [timeCount1, setTimeCount1] = useState([]);
    const [timeCount2, setTimeCount2] = useState([]);
    let newStrengths = [];
    const user = AuthService.getCurrentUser();
    const [friendshipD1, setFriendshipD1] = useState();
    const [headmasterD1, setHeadmasterD1] = useState(false);
    let labelsValueH1 = [], backgroundColorValueH1 = [], dataValueH1 = [];
    let labelsValueH2 = [], backgroundColorValueH2 = [], dataValueH2 = [];
    const [headmasterD2, setHeadmasterD2] = useState(false);
    const [friendshipD2, setFriendshipD2] = useState();

    useEffect(() => {
        if (!filterYear || !filterTerm) {
            console.log('Cannot read props')
            return;
        }
        UserService.getStrengths().then((response) => {
            for (const [index, str] of response.data.data.entries()) {
                newStrengths[str.id] = {
                    image: str.imageUrl,
                    name: str.name,
                    description: str.description
                }
            }
            // console.log('nin nin');
            // console.log(newStrengths);
            setStrengths(newStrengths)
            return newStrengths
        }).then((apiStrengths) => {
            var filter = {
                "domain": user.domain.name,
                "year": filterYear,
                "term": filterTerm,
            };
            // summaryStrength คืนทั้งนักเรียน (student) และครู (teacher) ในครั้งเดียว
            // โดยรวมทุก evaluationType ตาม group (ดู UserService.summaryStrength)
            UserService.summaryStrength(filter).then((result) => {

                // จุดเด่นของนักเรียน
                var studentData = result.student || [];
                setFriendshipD1(studentData);
                setHeadmasterD1(studentData.length > 0);
                var key1 = [];
                var timeCount1 = [];
                $.each(studentData, function (index, value) {
                    timeCount1[value.name] = value.total + " ครั้ง";
                    key1.push(value.name);
                    labelsValueH1.push(newStrengths[value.name]?.name);
                    backgroundColorValueH1.push(color[value.name]);
                    dataValueH1.push(value.total);
                });
                var gh1 = {
                    labels: labelsValueH1,
                    datasets: [
                        {
                            label: 'Rainfall',
                            backgroundColor: backgroundColorValueH1,
                            data: dataValueH1
                        }
                    ]
                };
                setHGraphData1(gh1);
                setSetKeyH1(key1);
                setTimeCount1(timeCount1);

                // จุดเด่นของคุณครู
                var teacherData = result.teacher || [];
                setFriendshipD2(teacherData);
                setHeadmasterD2(teacherData.length > 0);
                var key2 = [];
                var timeCount2 = [];
                $.each(teacherData, function (index, value) {
                    timeCount2[value.name] = value.total + " ครั้ง";
                    key2.push(value.name);
                    labelsValueH2.push(newStrengths[value.name]?.name);
                    backgroundColorValueH2.push(color[value.name]);
                    dataValueH2.push(value.total);
                });
                var gh2 = {
                    labels: labelsValueH2,
                    datasets: [
                        {
                            label: 'Rainfall',
                            backgroundColor: backgroundColorValueH2,
                            data: dataValueH2
                        }
                    ]
                };
                setHGraphData2(gh2);
                setSetKeyH2(key2);
                setTimeCount2(timeCount2);

            });
        });

    }, [filterYear, filterTerm])


    const color = {
        "brave": "#FFCECE",
        "honesty": "#FF9B9B",
        "perseverance": "#E04E4E",
        "zest": "#B41616",
        "fairness": "#A1AEF9",
        "citizenship": "#465BCC",
        "leadership": "#1A2979",
        "humility": "#FFD2F5",
        "forgiveness": '#FFA1E9',
        "self_regulation": "#D761BB",
        "prudence": "#801967",
        "hope": "#FFDEC8",
        "spirituality": "#FFC096",
        "beauty_excellence": "#EA833D",
        "humor": "#E46C1A",
        "gratitude": '#923806',
        "creativity": "#CDFFF6",
        "curiosity": '#8FFFEA',
        "judgement": "#67D2BE",
        "love_of_learning": "#2FA992",
        'perspective': '#147B68',
        "kindness": "#D8F4FF",
        "social": "#96DAF5",
        "love": "#2893BD",
    };

    const showHideSection = (section) => {
        console.log(section);
        var targetID = $('#' + section);
        var tragetClass = $('.' + section);
        if (targetID.hasClass('showhide-red')) {
            targetID.removeClass('showhide-red');
            targetID.addClass('showhide-green');
            tragetClass.hide();
        } else {
            targetID.removeClass('showhide-green');
            targetID.addClass('showhide-red');
            tragetClass.show();
        }
    }

    return (
        <>
            <Row className="font-sarabun mt-3 mb-3 mt-lg-5 mb-lg-4">
                <Col xs={12} className="text-center">
                    <h2 className="font-sarabun-bold mb-0">
                        5 อุปนิสัยเชิงบวกของนักเรียน และคุณครู
                    </h2>
                    <button className="btn-showhide border-gray showhide-red d-none d-lg-inline" id="showHideTopStrengthSummary" onClick={() => showHideSection('showHideTopStrengthSummary')}> </button>
                </Col>
            </Row>
            <Row className="font-sarabun top-strength-summary showHideTopStrengthSummary">
                <Col xs={12} lg={6} className="mt-3 mb-3 px-1">
                    <div className='summary-topic py-1 py-lg-2'>
                        จุดเด่นของนักเรียน
                    </div>
                    <div className={`summary-detail ${hGraphData2?.labels?.length > 0 ? 'expand-box' : ''}`}>
                        <div className='text-center py-3 mx-2'>5 จุดเด่นที่ถูกเลือกมากที่สุดในโรงเรียนจากการ<span className="doNotWrap">ประเมินทั้งหมด</span></div>

                        {
                            (hGraphData1?.labels?.length > 0) ? (
                                <div style={{ "position": "relative" }} className="py-3 m-0 p-0">
                                    <Col xs={6} md={6} className="h-graph">
                                        <div className="m-auto">

                                            <Doughnut
                                                data={hGraphData1}
                                                options={{
                                                    plugins: {
                                                        legend: {
                                                            display: false,
                                                            position: 'bottom'
                                                        }
                                                    },
                                                    responsive: true,
                                                    maintainAspectRatio: true
                                                }}
                                            />

                                        </div>
                                    </Col>

                                    <Col xs={7} md={6} style={{ "top": "0px", "right": "0px", "position": "absolute", "minHeight": "240px" }} className="d-flex pr-0">
                                        <div className="m-auto w-100">
                                            {keyH1.map((key, i) => (
                                                <Col xs={12} className="pl-3 pr-0 d-flex mb-2" key={key}>
                                                    <div className="d-inline div-dot" style={{ "backgroundColor": color[key] }}></div>
                                                    <div className="d-grid pl-2 text-left w-100"><h6 className="font-sarabun mb-0">{strengths[key].name} <span className="doNotWrap">{timeCount1[key]}</span></h6></div>
                                                </Col>
                                            ))}
                                        </div>
                                    </Col>

                                </div>

                            ) : (
                                <div className="text-center font-sarabun py-5">ยังไม่มีผลประเมิน</div>
                            )
                        }

                    </div>
                </Col>
                <Col xs={12} lg={6} className="mt-3 mb-3 px-1">
                    <div className='summary-topic py-1 py-lg-2'>
                        จุดเด่นของคุณครู
                    </div>
                    <div className={`summary-detail ${hGraphData1?.labels?.length > 0 ? 'expand-box' : ''}`}>
                        <div className='text-center py-3 mx-2'>5 จุดเด่นที่ถูกเลือกมากที่สุดในโรงเรียนจากการ<span className="doNotWrap">ประเมินทั้งหมด</span></div>
                        {
                            (hGraphData2?.labels?.length > 0) ? (
                                <div style={{ "position": "relative" }} className="py-3 m-0 p-0">
                                    <Col xs={6} md={6} className="h-graph">
                                        <div className="m-auto">

                                            <Doughnut
                                                data={hGraphData2}
                                                options={{
                                                    plugins: {
                                                        legend: {
                                                            display: false,
                                                            position: 'bottom'
                                                        }
                                                    },
                                                    responsive: true,
                                                    maintainAspectRatio: true
                                                }}
                                            />
                                        </div>
                                    </Col>

                                    <Col xs={7} md={6} style={{ "top": "0px", "right": "0px", "position": "absolute", "minHeight": "240px" }} className="d-flex pr-0">
                                        <div className="m-auto w-100">
                                            
                                            {strengths && keyH2.map((key, i) => (
                                                <Col xs={12} className="pl-3 pr-0 d-flex mb-2" key={key}>
                                                    <div className="d-inline div-dot" style={{ "backgroundColor": color[key] }}></div>                                                   
                                                    <div className="d-grid pl-2 text-left w-100"><h6 className="font-sarabun mb-0">{strengths[key].name} <span className="doNotWrap">{timeCount2[key]}</span></h6></div>
                                                </Col>
                                            ))}
                                        </div>
                                    </Col>

                                </div>
                            ) : (
                                <div className="text-center font-sarabun py-5">ยังไม่มีผลประเมิน</div>
                            )
                        }
                    </div>
                </Col>
            </Row>
        </>
    )

}

export default TopStrengthSummary